var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarlivaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "starliva-icon",
    transform: "translate(10383 -1724.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_2",
    "data-name": "Soustraction 2",
    d: "M78.5,157A78.523,78.523,0,0,1,47.941,6.169,78.519,78.519,0,0,1,109.051,150.83,78,78,0,0,1,78.5,157ZM94.551,65.294l-22.785,39.87h63.8L123.039,83.233H107.652V65.295h-13.1ZM55.82,35.39h0L15.949,105.164H67.188l14.25-24.949L55.82,35.391Zm58,27.406v15.71h15.7V62.8Zm-3.258-19.941h0L100.2,48.839l5.98,10.354,10.367-5.983-5.984-10.354Zm11.113,8.17v7.854h7.844V51.024Z",
    transform: "translate(-10383 1724.489)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarlivaIcon);
export default __webpack_public_path__ + "static/media/starliva-icon.d34ed5bb852224d347b15d8cb04b7d25.svg";
export { ForwardRef as ReactComponent };